import { render, staticRenderFns } from "./liste-sections-champs.html?vue&type=template&id=22b80b6a&scoped=true&external"
import script from "./liste-sections-champs.js?vue&type=script&lang=js&external"
export * from "./liste-sections-champs.js?vue&type=script&lang=js&external"
import style0 from "./liste-sections-champs.scss?vue&type=style&index=0&id=22b80b6a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b80b6a",
  null
  
)

export default component.exports